export const initial = {
    base_url: null,
    path: null,
    hash: null,
    submitting: false,
};

export function set(state, payload) {
    return { ...state, ...payload };
}



// WEBPACK FOOTER //
// ./app/reducers/compatibility-chooser.js